import React from 'react'

export default function Loading({text="Chargement"}) {
    return (
        <>
            <div className="text-center">
                    <div className="spinner-border" role="status">
                    <p className="visually-hidden">{text}...</p>
                </div>
            </div>
        </>
    )
}